<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                  clearable
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate">
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="customerCode"
                label="Customer Code"
                type="text"
                v-model="queryParams.customerCode"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="customerName"
                label="Customer Name"
                type="text"
                v-model="queryParams.customerName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                item-text="label"
                item-value="value"
                v-model="queryParams.status"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="saleTypeList"
                label="Sale Type"
                item-text="label"
                item-value="value"
                v-model="queryParams.saleType"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="shopList"
                label="Choose Shop..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                v-model="queryParams.shopId"
              ></v-select>
            </v-flex>
             <v-flex sm3>
                <v-autocomplete
                  v-model="queryParams.currencyId"
                  :items="currencyList"
                  color="blue-grey lighten-2"
                  label="Choose Currency..."
                  item-text="code"
                  menu-props="auto"
                  item-value="id"
                ></v-autocomplete>
              </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
          </v-card-title>
          <v-card-text class="font-weight-bold">
            <div>
              <span>Total Net Amount:</span>
              <v-chip>
                <span>{{ totalNetAmount | decFormat}}</span>
              </v-chip>
              <v-btn
                color="primary"
                :loading="printAllLoading"
                @click="printAll('printAll')"
              >PRINT ALL</v-btn>
              <v-btn
                :loading="printAllLoading"
                color="success"
                @click="exportAllCreditBalance()"
              >EXPORT ALL</v-btn>
            </div>
            <div>
              <span>Total Credit Paid Amount:</span>
              <v-chip>
                <span>{{ totalCreditPaidAmount | decFormat}}</span>
              </v-chip>
            </div>
            <div>
              <span>Total Remaining Amount:</span>
              <v-chip>
                <span>{{ totalRemainingAmount | decFormat}}</span>
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="customerCreditBalanceList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.createdDateInMilliSeconds | format-ms-date-time}}</td>
              <td>{{ props.item.customerCode }}</td>
              <td>{{ props.item.customerName }}</td>
              <td>{{ props.item.invoiceNo }}</td>
              <td>{{ props.item.shopName }}</td>
              <td>{{ props.item.periodDay }}</td>
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.netAmount | decFormat}}</td>
              <td>{{ props.item.creditPaidAmount | decFormat}}</td>
              <td>{{ props.item.remainingAmount | decFormat}}</td>
              <td>{{ props.item.saleType }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <!--Print All-->
    <div id="printAll" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center">
        <p style="font-size:18px;margin:1px">Customer Credit Balance</p>
      </div>
      <div style="text-align:center">
        <p
          style="font-size:15px;margin:1px"
        >From: [{{queryParams.fromDate | formatDate}}] To: [{{queryParams.toDate | formatDate}}]</p>
      </div>
     <div style="text-align:center">
        <p style="font-size:15px;margin:1px">Reported Date: [{{reportedDate}}]</p>
      </div>
      <br />
      <div style="padding-left:5px;padding-right:5px">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:12px;"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr>
              <th style="border:1px solid black;text-align:left">Shop</th>
              <th style="border:1px solid black;text-align:left">Customer</th>
              <th style="border:1px solid black;text-align:left">Invoice No.</th>
              <th style="border:1px solid black;text-align:left">Date</th>
              <th style="border:1px solid black;text-align:left">Sale Type</th>
              <th style="border:1px solid black;text-align:left">Net Amount</th>
              <th style="border:1px solid black;text-align:left">Credit Paid Amount</th>
              <th style="border:1px solid black;text-align:left">Remaining Amount</th>
            </tr>
          </thead>
          <tbody style="border:1px solid black;" v-for="(header, index) in customerCreditBalanceHeaderList" :key="index">
            <tr v-for="(item, i) in header.customerCreditBalanceList" :key="i">
              <td style="border-left:1px solid black;text-align:left" v-if="i==0">{{ item.shopName }}</td>
              <td style="border-left:1px solid black;text-align:left" v-else></td>
              <td style="border-left:1px solid black;text-align:left" v-if="i==0"> {{ header.customerName }} {{  '('+ item.customerCode + ')'}} </td>
              <td style="border-left:1px solid black;text-align:left" v-else></td>
              <td style="border:1px solid black;text-align:left">{{ item.invoiceNo }}</td>
              <td style="border:1px solid black;text-align:left">{{ item.createdDateInMilliSeconds | format-ms-date }}</td>
              <td style="border:1px solid black;text-align:left">{{ item.saleType }}</td>
              <td style="border:1px solid black;text-align:right">{{ item.netAmount | decFormat}}</td>
              <td style="border:1px solid black;text-align:right">{{ item.creditPaidAmount | decFormat}}</td>
              <td style="border:1px solid black;text-align:right">{{ item.remainingAmount | decFormat}}</td>
            </tr>
             <tr>
              <td style="border:1px solid black;font-weight:bold" colspan="5">Sub Total</td>
              <td style="border:1px solid black;font-weight:bold;text-align:right">{{header.subTotalNetAmount | decFormat}}</td>
              <td style="border:1px solid black;font-weight:bold;text-align:right">{{ header.subTotalCreditPaidAmount | decFormat}}</td>
              <td style="border:1px solid black;font-weight:bold;text-align:right">{{ header.subTotalRemainingAmount | decFormat}}</td>
            </tr>
          </tbody>
          <tr>
            <td style="border:1px solid black;font-weight:bold" colspan="5">Grand Total</td>
              <td style="border:1px solid black;font-weight:bold;text-align:right">{{ totalNetAmount | decFormat}}</td>
              <td style="border:1px solid black;font-weight:bold;text-align:right">{{ totalCreditPaidAmount | decFormat}}</td>
              <td style="border:1px solid black;font-weight:bold;text-align:right">{{ totalRemainingAmount | decFormat}}</td>
          </tr>
        </table>
      </div>
    </div>
    <!--Print All-->
  </v-container>
</template>

<script>
import { customerCreditBalanceService } from "../../services/customer-credit-balance-service";
import { commonService } from "../../services/common-service";
import { shopService } from "../../services/shop-service";
import { currencyService } from "../../services/currency-service";

export default {
  name: "CategoryList",

  components: {},
  data: () => ({
    showListLoading: false,
    printAllLoading: false,
    isSearch: false,
    breadcrumbs: [
      {
        text: "General",
        disabled: true
      },
      {
        text: "Customer Credit Balance",
        disabled: true
      }
    ],
    clonequeryParams: new Object(),
    headers: [
      {
        text: "Created Date",
        align: "left",
        value: "createdDate",
        sortable: false
      },
      { text: "Customer Code", value: "customerCode", sortable: false },
      { text: "Customer Name", value: "customerName", sortable: false },
      { text: "Invoice No.", value: "invoiceNo", sortable: false },
      { text: "Shop", value: "shop", sortable: false },
      { text: "Period Day", value: "periodDay", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "Net Amount", value: "netAmount", sortable: false },
      {
        text: "Credit Paid Amount",
        value: "creditPaidAmount",
        sortable: false
      },
      { text: "Remaining Amount", value: "remainingAmount", sortable: false },
      { text: "Sale Type", value: "saleType", sortable: false }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      totalItems: 0
    },
    currencyList: [],
    customerCreditBalanceList: [],
    allCustomerCreditBalanceList: [],
    customerCreditBalanceHeaderList: [],
    totalRows: 0,
    statusList: [
      { label: "----All----", value: "" },
      { label: "FINISH", value: "FINISH" },
      { label: "CREDIT", value: "CREDIT" }
    ],
     reportedDate:  commonService.formatDate(new Date(), "DD/MM/YYYY"),
    queryParams: {
      status: "",
      saleType: "",
      customerCode: "",
      customerName: "",
      fromDate: "",
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      shopId: "",
      currencyId: ""
    },
    saleTypeList: [
      { label: "----All----", value: "" },
      { label: "RETAIL", value: "RETAIL" },
      { label: "WHOLE_SALE", value: "WHOLE_SALE" }
    ],
    totalNetAmount: 0,
    totalCreditPaidAmount: 0,
    totalRemainingAmount: 0,
    shopList: []
  }),
  watch: {
    pagination: {
      handler() {
        if(this.isSearch){
          this.findCustomerCreditBalance();
        }
      },
      deep: true
    }
  },
  created() {
    //for deep linking
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.saleType) {
      this.queryParams.saleType = this.$route.query.saleType;
    }
    if (this.$route.query.customerCode) {
      this.queryParams.customerCode = this.$route.query.customerCode;
    }
    if (this.$route.query.customerName) {
      this.queryParams.customerName = this.$route.query.customerName;
    }
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    if(this.isSearch){
      this.onSearch();
      this.findCustomerCreditBalanceSummary();
    }
    this.getAllShop();
    this.getActiveCurrency()
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "CustomerCreditBalance",
        query: this.queryParams
      });
      this.clonequeryParams = Object.assign({}, this.queryParams);
      this.findCustomerCreditBalance();
      this.findCustomerCreditBalanceSummary();
      this.isSearch=true;
    },
    findCustomerCreditBalance() {
      this.showListLoading = true;
      customerCreditBalanceService
        .getCustomerCreditBalance(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage
        )
        .then(res => {
          if (res.data) {
            this.customerCreditBalanceList = res.data.customerCreditBalanceList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    findCustomerCreditBalanceSummary() {
      customerCreditBalanceService
        .getCustomerCreditBalanceSummary(this.queryParams)
        .then(res => {
          if (res.data) {
            this.totalNetAmount = res.data.totalNetAmount;
            this.totalCreditPaidAmount = res.data.totalCreditPaidAmount;
            this.totalRemainingAmount = res.data.totalRemainingAmount;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    printAll(divName) {
      this.printAllLoading = true;
      customerCreditBalanceService
        .printCustomerCreditBalance(this.clonequeryParams, null, null)
        .then(res => {
          if (res.data) {
            this.customerCreditBalanceHeaderList =
                  res.data;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllLoading = false;
        });
    },
    exportAllCreditBalance() {
      this.printAllLoading = true;
      customerCreditBalanceService
        .exportCreditBalanceExcel(this.queryParams)
        .then(res => {
          commonService.downloadE(res);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.printAllLoading = false;
        });
    },
    getActiveCurrency(){
    return currencyService.getCurrencyByStatus('ACTIVE')
    .then(res => {
      if(res.data){
        this.currencyList = res.data;
        let c = commonService.search("defaultCurrency",true,this.currencyList);
        if(c){
          this.queryParams.currencyId = c.id;
        }
      }
    })
    .catch((err) => {
          if (err.response.data) {
            this.responseError = err.responseError.data.message;
          }
        });
    },
    getAllShop() {
      shopService
        .getAllShop()
        .then(res => {
          this.shopList = res.data;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.shopList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    }
  },
};
</script>